import React, { useEffect, useRef } from 'react';
import { View, Text, Image, Animated, Easing, useWindowDimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

export default function ComingSoonScreen() {
	const fadeIn = useRef(new Animated.Value(0)).current;
	const slideUp = useRef(new Animated.Value(20)).current;
	const pulse = useRef(new Animated.Value(1)).current;
	const { width, height } = useWindowDimensions();
	const isSmall = width < 420;
	const isMedium = width < 768;

	useEffect(() => {
		Animated.sequence([
			Animated.parallel([
				Animated.timing(fadeIn, { toValue: 1, duration: 800, easing: Easing.out(Easing.cubic), useNativeDriver: true }),
				Animated.timing(slideUp, { toValue: 0, duration: 800, easing: Easing.out(Easing.cubic), useNativeDriver: true }),
			]),
			Animated.loop(
				Animated.sequence([
					Animated.timing(pulse, { toValue: 1.06, duration: 1200, easing: Easing.inOut(Easing.quad), useNativeDriver: true }),
					Animated.timing(pulse, { toValue: 1.0, duration: 1200, easing: Easing.inOut(Easing.quad), useNativeDriver: true }),
				])
			)
		]).start();
	}, [fadeIn, slideUp, pulse]);

	return (
		<LinearGradient
			colors={["#ffffff", "#61CAFB"]}
			start={{ x: 0.5, y: 0 }}
			end={{ x: 0.5, y: 1 }}
			style={{ flex: 1, width: '100%', minHeight: height, height: '100vh' }}
		>
			<View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', paddingHorizontal: isSmall ? 16 : 24, paddingVertical: isSmall ? 32 : 48 }}>
				<Animated.View style={{ alignItems: 'center', transform: [{ translateY: slideUp }], opacity: fadeIn }}>
					<Animated.Image
						source={require('../assets/SMM Logo.png')}
						style={{ width: isSmall ? 140 : isMedium ? 180 : 220, height: isSmall ? 140 : isMedium ? 180 : 220, resizeMode: 'contain', transform: [{ scale: pulse }] }}
						accessibilityLabel="SyncMyRide logo"
					/>
					<Text style={{ marginTop: 16, fontSize: isSmall ? 32 : isMedium ? 40 : 48, fontWeight: '800', color: '#0a0a0a', textAlign: 'center', letterSpacing: -1 }}>SyncMyRide</Text>
					<Text style={{ marginTop: 12, fontSize: isSmall ? 20 : 24, color: '#1b2730', textAlign: 'center', fontWeight: '600' }}>Coming Soon</Text>
					<Text style={{ marginTop: 20, textAlign: 'center', color: '#1b2730', maxWidth: isSmall ? 320 : 640, fontSize: isSmall ? 15 : 17, lineHeight: isSmall ? 22 : 26 }}>
						We're building something awesome. Check back shortly.
					</Text>
				</Animated.View>
			</View>
		</LinearGradient>
	);
}